import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
    render() {
        return (
            <div className="main-banner-wrapper">
                <div className="main-banner-single">
                    <div className="overlay overlay-bg-black banner-img" />
                </div>
                <div className="banner-text transform-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="content-wrapper">
                                    <h1 className="text-white">Marijuana Treatments</h1>
                                    <h4 className="text-white">Cannabis provide various method like tinctures, cancer</h4>
                                    <Link to="/about" className="btn-submit btn_text_effect btn-effect"><span className="button_title">Learn More</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Banner;